<template>
  <div>
    <!-- MACHINE INFORATION -->
    <div class="contentWrap" style="padding-bottom: 0;">
      <p class="contentTitle">Machine information</p>
      <P class="headerP">
        <span>Device name</span>
        <span>{{ basicinfo.deviceName }}</span>
      </P>
      <P class="headerP">
        <span>Serial number</span>
        <span>{{ basicinfo.deviceSn }}</span>
      </P>
      <P class="headerP">
        <span>Machine model</span>
        <span>{{ basicinfo.mechBrand }} / {{ basicinfo.mechModel }}</span>
      </P>
      <P class="headerP">
        <span>Firmware version</span>
        <!-- <span>{{ basicinfo.deviceName }}</span> -->
        <span>V {{ basicinfo.fwVersion }}</span>
      </P>
    </div>

    <!-- STATUS/MAP -->
    <div style="margin-top:20px;">
      <!-- STATUS -->
      <div class="contentWrap statuWrap">
        <p class="contentTitle">Status
          <span v-show="timeAgoStatusRET" class="timeAgo">{{ timeAgoStatus }}</span>
          <span v-show="!timeAgoStatusRET" class="timeAgo">{{ $t('dataAndTime.waitingUpdate') }}</span>
        </p>
        <P class="statuP">
          <span>Battery model</span>
          <span>{{ basicinfo.batteryBrand }}&nbsp;{{ basicinfo.batteryModel }}</span>
        </P>
        <P class="statuP">
          <span>Battery capacity</span>
          <span>{{ basicinfo.batteryCapacity }}</span>
        </P>
        <P class="statuP">
          <span>System voltage</span>
          <span>{{ basicinfo.batteryVoltage }}</span>
        </P>
        <P class="statuP">
          <span>SOC </span>
          <span>{{ statuList.soc }}</span>
        </P>
        <P class="statuP">
          <span>Current</span>
          <span>{{ statuList.current }}</span>
        </P>
        <P class="statuP">
          <span>Voltage</span>
          <span>{{ statuList.voltageRaw }}</span>
        </P>
        <P class="statuP">
          <span>Temperature</span>
          <span>{{ statuList.batteryTemperature }}</span>
        </P>
      </div>
      <!-- Map -->
      <div class="contentWrap statuWrap" style="margin: 0 0 0 20px;vertical-align: top;">
        <p class="contentTitle" style="display:inline-block;margin-right:10px;border:none;">Map</p>
        <!-- <el-switch v-model="value1" inactive-text="谷歌地图" active-text="高德地图" /> -->
        <div style="height:280px;">
          <!-- 地图------start -->
          <div style="min-height:100px;width: 100%;position:relative;">
            <!-- 高德地图 和 谷歌地图-->
            <el-container style="padding-left: 1px;padding-right: 1px;position: relative;background:white;border-radius: 10px;" class="right"><!--0925 cici-->
              <keep-alive>
                <deviceListMapTem ref="maps" :is-show-g-d-map="value1" :have-location-info="haveLocationInfo" :height="height" :location-array="locationList" @fullScreen="fullScreen" />
              </keep-alive>
            </el-container>
            <!-- 悬浮框 -->
            <div class="mapFloatBox">
              <p class="mapFloatBoxTitle">Location information</p>
              <p>Degree of latitude : {{ location.lat }}</p>
              <p>Degree of longitude : {{ location.lon }}</p>
              <p>Latest update : {{ location.latestUpdate }}</p>
            </div>
          </div>
          <!-- 地图------end -->
        </div>
      </div>
    </div>

    <!-- REALTIME INFORATION -->
    <div class="contentWrap">
      <p class="contentTitle">Realtime information
        <span v-show="timeAgoRET" class="timeAgo">{{ timeAgo }}</span>
        <span v-show="!timeAgoRET" class="timeAgo">{{ $t('dataAndTime.waitingUpdate') }}</span>
        <el-button type="primary" size="mini" icon="el-icon-refresh-right" style="vertical-align: top;margin: 10px;position: relative;z-index: 999;" @click="setRealInfoFn" />
        <el-button type="primary" size="mini" icon="el-icon-setting" style="vertical-align: top;margin: 10px;float:right;position: relative;z-index: 999;" @click="setRealInfoPop=true" />
      </p>
      <div class="realtimeWrap">
        <div class="realtimeDivs">
          <p>FLASHCODE</p>
          <p>{{ flashcodeV }}</p>
        </div>
        <div class="realtimeDivs">
          <p>LOAD</p>
          <p>{{ loadV }}</p>
        </div>
        <div class="realtimeDivs">
          <p>HEIGHT</p>
          <p>{{ heightV }}</p>
        </div>
        <div class="realtimeDivs">
          <p>TILT-X</p>
          <p>{{ tiltX }}</p>
        </div>
        <div class="realtimeDivs">
          <p>TILT-Y</p>
          <p>{{ tiltY }}</p>
        </div>
      </div>
    </div>
    <!-- 设置--弹窗 -->
    <el-dialog id="setRealInfoDiv" :close-on-click-modal="false" :visible.sync="setRealInfoPop" width="60%">
      <el-form ref="setRealInfoRef" :rules="rules" :model="setRealInfo" label-position="right" label-width="150px" :inline="true">
        <el-row :gutter="40">
          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-form-item label="Nodeid" prop="Nodeid">
              <el-input v-model="setRealInfo.Nodeid" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-form-item label="Telelock" prop="Telelock">
              <el-input v-model="setRealInfo.Telelock" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-form-item label="Telespeed" prop="Telespeed">
              <el-input v-model="setRealInfo.Telespeed" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-form-item label=" " prop=" ">
              <p>PS:Please enter number</p>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
            <el-form-item style="text-align: end;">
              <el-button @click="setRealInfoPop = false">{{ $t('button.Cancel') }}</el-button>
              <el-button class="filter-item" type="primary" @click="submitSetRealInfo('setRealInfoRef')">{{ $t('button.Submit') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- WARNING -->
    <div class="contentWrap" style="padding-bottom: 0;">
      <!-- <p class="contentTitle">{{ $t('basicinfo.warning') }}</p> -->
      <p class="contentTitle">Warning message</p>
      <div class="warningWrap">
        <div v-for="(item,index) in warningList" :key="index" class="warningDivs">
          <!-- <div style="width:120px;height:120px;display: inline-block;" :title="item.isColor" :style="{background:item.imgUrl}" /> -->
          <img style="width:90px;height:90px;display: inline-block;" :src="item.imgUrl">
          <p style="margin-top: 5px;">{{ item.name }}</p>
        </div>
      </div>
    </div>

    <!-- COMPANY INFORATION -->
    <div class="contentWrap" style="padding-bottom: 0;">
      <p class="contentTitle">Company information</p>
      <P class="companyP">
        <span>Name</span>
        <span>Tronic Group</span>
      </P>
      <!-- <P class="companyP">
        <span>Email</span>
        <span>{{ basicinfo.companyEmail }}</span>
      </P> -->
      <P class="companyP">
        <span>Website</span>
        <a :href="basicinfo.companyUrl" target="_self"><span>http://www.trionicusa.com</span></a>
      </P>
    </div>
  </div>

</template>

<script>
import { getGNSSLastByMcuID } from '@/api/location'
import { findDeviceInfo, sendPGTData } from '@/api/trionic'
import deviceListMapTem from '@/components/deviceListMapTem'// 高德和谷歌地图
import { updateTime, getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'
import { GetRealTimeData } from '@/api/leaseManagement'

export default {
  components: {
    deviceListMapTem // 地图
  },
  data() {
    this.yhubproto
    this.protobuf
    return {
      // 地图----start
      height: '260px',
      value1: false,
      locationList: [],
      isShowMapFloat: false, // 是否显示图示
      haveLocationInfo: true, // 是否有定位信息
      // 地图----end

      yhubmqtt: {},
      flashcodeV: '--',
      loadV: '--',
      heightV: '--',
      tiltX: '--',
      tiltY: '--',
      deviceID: '',
      basicinfo: {
        batteryCapacity: '--',
        batteryVoltage: '--'
      },
      statuList: {
        current: '--',
        voltageRaw: '--',
        batteryTemperature: '--',
        soc: '--'
      },
      timeAgo: '',
      timeAgoRET: '',
      timeAgoStatus: '',
      timeAgoStatusRET: '',
      msg: null,
      location: {},
      warningListOld: [],
      warningList: [{ name: 'OVERHEIGHT', isColor: 'false', imgUrl: require('@/assets/images/overheight_gray.png') },
        { name: 'TILTED', isColor: 'false', imgUrl: require('@/assets/images/tilted_gray.png') },
        { name: 'EXTENDED', isColor: 'false', imgUrl: require('@/assets/images/extended_gray.png') },
        { name: 'TOOHOT', isColor: 'false', imgUrl: require('@/assets/images/E7_gray.png') },
        { name: 'OVERLOADED', isColor: 'false', imgUrl: require('@/assets/images/overloaded_gray.png') },
        { name: 'LOWBATT', isColor: 'false', imgUrl: require('@/assets/images/E5_gray.png') },
        { name: 'DEADBATT', isColor: 'false', imgUrl: require('@/assets/images/deadbatt_gray.png') },
        { name: 'BADOVL', isColor: 'false', imgUrl: require('@/assets/images/badovl_gray.png') },
        { name: 'BADSENSORS', isColor: 'false', imgUrl: require('@/assets/images/badsensors_gray.png') }],
      setRealInfoPop: false,
      setRealInfo: {
        Nodeid: 41,
        Telelock: 81,
        Telespeed: 130
      },
      rules: {
        Nodeid: [{ required: true, message: 'Please enter the Nodeid', trigger: 'blur' }], // 激活码不能为空
        Telelock: [{ required: true, message: 'Please enter the Telelock', trigger: 'blur' }], // 激活码不能为空
        Telespeed: [{ required: true, message: 'Please enter the Telespeed', trigger: 'blur' }] // 激活码不能为空
      }
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.mqttMSG()
      },
      deep: true
    }
  },
  mounted() {
    console.log(this.$store)
    if (this.$store.state.map == 'gdMap') { this.value1 = true } else { this.value1 = false }

    this.mcuId = this.$route.query.mcuId
    this.deviceID = 'WEB2_' + this.mcuId + '_' + this.getuuid()
    this.warningListOld = JSON.parse(JSON.stringify(this.warningList))
    this.queryList()
    GetRealTimeData({ mcuId: this.$route.query.mcuId }).then(res => {})
    this.$nextTick(() => {
      this.mqttMSG()
    })
  },
  created() {
    this.setTimer()
  },
  destroyed: function() {
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    // 获取地址信息--高德地图
    getPosition({ address, lat, lng, name }) {
      this.postForm.detailedAddress = address
      this.postForm.longitude = String(lng)
      this.postForm.latitude = String(lat)
    },
    fullScreen(height) {
      this.height = height
    },
    // 查询
    queryList() {
      var param = {
        'mcuId': this.$route.query.mcuId,
        myToken: this.$store.state.token
      }
      findDeviceInfo(param).then(response => {
        this.basicinfo = response.resultModel
        if (this.basicinfo.batteryCapacity || this.basicinfo.batteryCapacity == 0) this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 1000 ? (this.basicinfo.batteryCapacity / 100 + 'Ah') : (this.basicinfo.batteryCapacity + 'Ah')
        else { this.basicinfo.batteryCapacity = '--' }
        if (this.basicinfo.batteryVoltage || this.basicinfo.batteryVoltage == 0) this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 100 ? (this.basicinfo.batteryVoltage / 100 + 'V') : (this.basicinfo.batteryVoltage + 'V')
        else { this.basicinfo.batteryVoltage = '--' }
      })

      getGNSSLastByMcuID(param).then(res => {
        if (res.resultCode !== 1001 || res.resultModel == null) {
          return
        }
        this.locationList = []
        var locatin = {}
        locatin.davaceName = this.basicinfo.deviceName
        locatin.mcuId = this.$route.query.mcuId
        locatin.lType = res.resultModel.lType
        this.location.lat = locatin.lat = res.resultModel.lat
        this.location.lon = locatin.lon = res.resultModel.lon
        locatin.updataTime = res.resultModel.updataTime
        this.location.latestUpdate = getDateAndHour(new Date().getTime(), 'noSecond')
        this.locationList.push(locatin)
        // debugger
        // this.gMap.setMakers()
        if (!res.resultModel.lat || !res.resultModel.lon) { this.haveLocationInfo = false } else { this.haveLocationInfo = true }
        this.$refs.maps.setMakers(this.locationList)
        var center = {
          lat: res.resultModel.lat,
          lon: res.resultModel.lon,
          radius: '100'
        }
        // this.$refs.maps.setCenter(center)
      })
    },
    mqttMSG() {
      if (this.yhubmqtt) {
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.mcuId) == -1) return
        console.log('收到数据======', JSON.stringify(this.yhubmqtt))
        if (this.yhubmqtt.payload === 'mRealTimeData') {
          if (!this.yhubmqtt.mRealTimeData.dRecord) return
          this.statuList = JSON.parse(JSON.stringify(this.yhubmqtt.mRealTimeData.dRecord))
          console.log('this.yhubmqtt.mRealTimeData-----', this.yhubmqtt.mRealTimeData)
          if (this.statuList.currentCharging && this.statuList.currentDischarging) {
            this.statuList.current = ((this.statuList.currentCharging - this.statuList.currentDischarging) / 100).toFixed(2) + 'A'
            // if (current >= 0) { this.statuList.current = current } else { this.statuList.current = -current }
          } else { this.statuList.current = 0 + 'A' }
          if (this.statuList.soc && this.statuList.soc != '--') this.statuList.soc = Math.round(this.statuList.soc / 100) + '%'
          this.statuList.voltageRaw = this.statuList.voltageRaw / 100 + 'V'
          this.statuList.batteryTemperature = Math.round(this.statuList.batteryTemperature / 100) + '℃'
          this.timeAgoStatus = i18n.t('dataAndTime.AMomentAgo')
          this.timeAgoStatusRET = new Date().getTime()
        }
        if (this.yhubmqtt.payload === 'mCan') {
          if (this.yhubmqtt.mCan.payload === 'mPgtData') {
            console.log('mCan======', this.yhubmqtt.mCan)
            this.timeAgo = i18n.t('dataAndTime.AMomentAgo')
            this.timeAgoRET = new Date().getTime()
            var pgtinfo = this.yhubmqtt.mCan.mPgtData.pgtdata
            // console.log(pgtinfo)
            if (pgtinfo.length == 0 || !pgtinfo[0].data || !pgtinfo[1].data) return
            // var pgtinfo=['aa','bb','cc']
            pgtinfo.forEach((v, i) => { // v:数组的每一项  i:每一项的索引
              // v:aa  bb  cc
              // i:0,1,2
              // debugger
              if (v.frameId - this.setRealInfo.Nodeid == 0x180) {
                // console.log('v.data----', v.data)
                this.flashcodeV = v.data[0]
                if (v.data[3] > 99 && v.data[3] < 201) { this.loadV = v.data[3] - 100 + ' %' } else { this.loadV = 'UNKNOWN' }
                if (v.data[2] > 99 && v.data[2] < 201) { this.heightV = v.data[2] - 100 + ' %' } else { this.heightV = 'UNKNOWN' }
                var status1 = v.data[4] // 4
                var status2 = v.data[5] // 6
                var status3 = v.data[6] // 7
                if (status1 !== 0) {
                  if (this.getBit(status1, 1)) { this.warningList[0].isColor = 'true'; this.warningList[0].imgUrl = require('@/assets/images/overheight_color.png') } // status转换为二进制，即 八个bit组成的数组，其中第1位是否为1，若为1，则为true
                  else { this.warningList[0].imgUrl = this.warningListOld[0].imgUrl }
                } else {
                  this.warningList[0].imgUrl = this.warningListOld[0].imgUrl
                }
                if (status2 !== 0) {
                  if (this.getBit(status2, 0)) { this.warningList[1].isColor = 'true'; this.warningList[1].imgUrl = require('@/assets/images/tilted_color.png') } else { this.warningList[1].imgUrl = this.warningListOld[1].imgUrl }
                  if (this.getBit(status2, 1)) { this.warningList[2].isColor = 'true'; this.warningList[2].imgUrl = require('@/assets/images/extended_color.png') } else { this.warningList[2].imgUrl = this.warningListOld[2].imgUrl }
                  if (this.getBit(status2, 3)) { this.warningList[3].isColor = 'true'; this.warningList[3].imgUrl = require('@/assets/images/E7.png') } else { this.warningList[3].imgUrl = this.warningListOld[3].imgUrl }
                } else {
                  this.warningList[1].imgUrl = this.warningListOld[1].imgUrl
                  this.warningList[2].imgUrl = this.warningListOld[2].imgUrl
                  this.warningList[3].imgUrl = this.warningListOld[3].imgUrl
                }
                if (status3 !== 0) {
                  if (this.getBit(status3, 0)) { this.warningList[4].isColor = 'true'; this.warningList[4].imgUrl = require('@/assets/images/overloaded_color.png') } else { this.warningList[4].imgUrl = this.warningListOld[4].imgUrl }
                  if (this.getBit(status3, 1)) { this.warningList[5].isColor = 'true'; this.warningList[5].imgUrl = require('@/assets/images/E5.png') } else { this.warningList[5].imgUrl = this.warningListOld[5].imgUrl }
                  if (this.getBit(status3, 2)) { this.warningList[6].isColor = 'true'; this.warningList[6].imgUrl = require('@/assets/images/deadbatt_color.png') } else { this.warningList[6].imgUrl = this.warningListOld[6].imgUrl }
                  if (this.getBit(status3, 6)) { this.warningList[7].isColor = 'true'; this.warningList[7].imgUrl = require('@/assets/images/badovl_color.png') } else { this.warningList[7].imgUrl = this.warningListOld[7].imgUrl }
                  if (this.getBit(status3, 7)) { this.warningList[8].isColor = 'true'; this.warningList[8].imgUrl = require('@/assets/images/badsensors_color.png') } else { this.warningList[8].imgUrl = this.warningListOld[8].imgUrl }
                } else {
                  this.warningList[4].imgUrl = this.warningListOld[4].imgUrl
                  this.warningList[5].imgUrl = this.warningListOld[5].imgUrl
                  this.warningList[6].imgUrl = this.warningListOld[6].imgUrl
                  this.warningList[7].imgUrl = this.warningListOld[7].imgUrl
                  this.warningList[8].imgUrl = this.warningListOld[8].imgUrl
                }
              } else if (v.frameId - this.setRealInfo.Nodeid == 0x280) {
                const bufferX = new Buffer([v.data[1], v.data[0], 0, 0])
                this.tiltX = bufferX.readUInt32LE(0)
                if (this.tiltX === 0) {
                  this.tiltX = 'LEVEL'
                } else if (this.tiltX > 64536 && this.tiltX < 65536) {
                  this.tiltX = (65536 - this.tiltX)
                  this.tiltX = (this.tiltX / 10.0).toFixed(1) + '°'
                } else if (this.tiltX > 0 && this.tiltX < 999) {
                  this.tiltX = (this.tiltX / 10.0).toFixed(1) + '°'
                } else {
                  this.tiltX = 'UNKNOWN'
                }
                const bufferY = new Buffer([v.data[3], v.data[2], 0, 0])

                this.tiltY = bufferY.readUInt32LE(0)

                if (this.tiltY === 0) {
                  this.tiltY = 'LEVEL'
                } else if (this.tiltY > 64536 && this.tiltY < 65536) {
                  this.tiltY = (65536 - this.tiltY)
                  this.tiltY = (this.tiltY / 10.0).toFixed(1) + '°'
                } else if (this.tiltY > 0 && this.tiltY < 999) {
                  this.tiltY = (this.tiltY / 10.0).toFixed(1) + '°'
                } else {
                  this.tiltY = 'UNKNOWN'
                }
              } else if (v.frameId - this.setRealInfo.Nodeid == 0x380) {

              }
            })

            var pgtdata1 = pgtinfo[0].data
            var pgtdata2 = pgtinfo[1].data
            // var pgtdata3 = pgtinfo[2].data

            // console.log('pgtdata1=====', pgtdata1)
          }
        }
        console.log('warningList-----------', this.warningList)
        this.msg = this.yhubmqtt
      }
    },
    setRealInfoFn() { // 刷新
      var param = {
        mcuId: this.$route.query.mcuId,
        set_nodeid: this.setRealInfo.Nodeid,
        telelock: this.setRealInfo.Telelock,
        telespeed: this.setRealInfo.Telespeed
      }
      sendPGTData(param).then(res => {
        if (res.code == 200) {
          this.setRealInfoPop = false
          this.$message({
            type: 'success',
            message: 'Succeed!'
          })
        } else {
          this.$message({
            type: 'error',
            message: 'Error!'
          })
        }
      })
    },
    submitSetRealInfo(formName) { // 设置弹窗--提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setRealInfoFn()
        }
      })
    },
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgoRET) this.timeAgo = updateTime(this.timeAgoRET)
          if (this.timeAgoStatusRET) this.timeAgoStatus = updateTime(this.timeAgoStatusRET)
        }, 60000)
      }
    },
    // uuid随机生成
    getuuid() {
      var uid = []
      var hexDigits = '0123456789abcdefghijklmnopqrst'
      for (var i = 0; i < 32; i++) {
        uid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      uid[6] = '4'
      uid[15] = hexDigits.substr((uid[15] & 0x3) | 0x8, 1)
      var uuid = uid.join('')
      return uuid
    },
    getBit(n, k) {
      var bx = false
      if (((n >> k) & 1) == 1) {
        bx = true
      } else {
        bx = false
      }
      return bx
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0;
  padding:0;
}
.contentTitle{
  height:50px;
  line-height:50px;
  border-bottom: 2px solid #e6e9ed;
}
.headerP{
  width: calc(50% - 13px);
  display: inline-block;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #606266;
}
.headerP:nth-of-type(odd){  //奇数
  margin-left:20px;
}
.headerP:nth-child(n+4){
  border-top: 1px solid #e6e9ed;
}
.headerP span{
  padding-left:20px;
}
.headerP span:nth-of-type(odd){
  width:50%;
  display: inline-block;
}
.statuP{
  width: 100%;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid rgb(230, 233, 237);
  font-size: 14px;
  color: #606266;
}
.statuP span{
  padding-left:20px;
}
.statuP span:nth-of-type(odd){
  width:50%;
  display: inline-block;
}
.statuP:last-child{
  border-bottom: none;
}
.statuWrap{
  width:calc(50% - 13px);
  padding-bottom: 0;
  display:inline-block;
}
.mapFloatBox{
  position: absolute;
  width: 314px;
  // height: 137px;
  bottom: 0;
  right: 0;
  background: rgba(0,0,0,0.5);
  color: white;
  padding: 10px 20px;
}
.mapFloatBox p{
  font-size: 14px;
  line-height: 28px;
}
.mapFloatBox p.mapFloatBoxTitle{
  font-size: 16px;
  margin-bottom: 5px;
}
.timeAgo{
  font-size: 16px;
  color: #ff9933;
  margin-left: 10px;
}
.realtimeWrap{
  background:#3399ff;
  height:262px;
  padding-top: 93px;
  color: white;
  font-size: 16px;
}
.realtimeDivs{
  height:76px;
  border-right:1px solid white;
  display: inline-block;
  width: calc(20% - 4px);
  text-align: center;
  padding: 5px 0;
}
.realtimeDivs:last-child{
  border-right:none;
}
.realtimeDivs p:nth-of-type(2){
  font-size: 30px;
  line-height: 48px;
}
.warningWrap{
  height:280px;
  padding:70px 0;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  text-align: center;
  overflow-y: auto;
}
.warningDivs{
  display: inline-block;
}
.companyP{
  height:50px;
  line-height: 50px;
  font-size: 14px;
  color: #606266;
  border-bottom: 1px solid #e6e9ed;
}
.companyP:last-child{
  border-bottom:none;
}
.companyP span{
  padding-left:20px;
}
.companyP span:nth-of-type(odd){
  width:30%;
  display: inline-block;
}
</style>
<style lang="scss">
#setRealInfoDiv{
  .el-dialog{
    max-width:600px;
  }
  .el-form-item{
    width:100%!important;
  }
  .el-form-item__content {
    width: calc(100% - 200px)!important;
  }
}
</style>
